// extracted by mini-css-extract-plugin
module.exports = {"hide-image":"_1kedS","img-loading":"_1zIil","cover-container":"_3JljG","onboarding-img":"_1BYSa","shake":"_1VpGU"};